// Shared fields for lab create/edit.

export default function LabFields({ form, setField, fieldError, disabled, showStatus = false }) {
    return (
        <div className="cat-form__grid">
            <label className="cat-form__field cat-form__field--full">
                <span className="cat-form__label">Nombre</span>
                <input
                    type="text"
                    value={form.name}
                    onChange={(e) => setField('name', e.target.value)}
                    maxLength={120}
                    disabled={disabled}
                    autoFocus
                    aria-invalid={!!fieldError('name')}
                />
                {fieldError('name') && <span className="cat-form__error" role="alert">{fieldError('name')}</span>}
            </label>

            <label className="cat-form__field cat-form__field--full">
                <span className="cat-form__label">Ubicación</span>
                <input
                    type="text"
                    value={form.location}
                    onChange={(e) => setField('location', e.target.value)}
                    maxLength={255}
                    disabled={disabled}
                    placeholder="Ciudad / dirección (opcional)"
                    aria-invalid={!!fieldError('location')}
                />
                {fieldError('location') && <span className="cat-form__error" role="alert">{fieldError('location')}</span>}
            </label>

            {showStatus && (
                <label className="cat-form__field">
                    <span className="cat-form__label">Estado</span>
                    <select
                        value={form.status}
                        onChange={(e) => setField('status', Number(e.target.value))}
                        disabled={disabled}
                    >
                        <option value={2}>Activo</option>
                        <option value={1}>Inactivo</option>
                    </select>
                </label>
            )}
        </div>
    );
}
